<nb-card-body>
  <ng2-smart-table [settings]="settings"
                   [source]="source"
                   (delete)="deleteRecord($event)"
                   (createConfirm)="addRecord($event)"
                   (editConfirm)="editRecord($event)">
  </ng2-smart-table>
</nb-card-body>
